import type * as lazyMyOutlookSection from './MyOutlookSection';
import {
    createLazyComponent,
    type LazyComponent,
    LazyModule,
    LazyAction,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { openToday } from 'owa-personal-os-public-actions';
import MyOutlookSectionPlaceholder from './MyOutlookSectionPlaceholder';

export type { MyOutlookSectionProps } from './MyOutlookSection';
type MyOutlookSectionProps = lazyMyOutlookSection.MyOutlookSectionProps;

const lazyModule: LazyModule<typeof lazyMyOutlookSection> = new LazyModule(
    () => import(/* webpackChunkName: "MyOutlookSection" */ './MyOutlookSection'),
    { name: 'MyOutlookSection' }
);

registerLazyOrchestrator(openToday, lazyModule, module => module.openTodayOrchestrator);

export const LazyMyOutlookSection: LazyComponent<
    MyOutlookSectionProps,
    HTMLDivElement,
    HTMLDivElement
> = createLazyComponent(lazyModule, m => m.default, MyOutlookSectionPlaceholder);

export const lazyOpenMyOutlookFullPage: LazyAction<
    typeof lazyMyOutlookSection.openMyOutlookFullPage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openMyOutlookFullPage);

export const lazyDismissMyOutlookFullPage: LazyAction<
    typeof lazyMyOutlookSection.dismissMyOutlookFullPage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.dismissMyOutlookFullPage);

// Lightweight flag set by MyOutlookSection on mount/unmount to avoid
// eagerly loading the lazy chunk on every folder click.
let myOutlookFullPageActive = false;
export function setMyOutlookFullPageActive(active: boolean): void {
    myOutlookFullPageActive = active;
}
export function isMyOutlookFullPageActive(): boolean {
    return myOutlookFullPageActive;
}
